export default {
    home: "Home",
    projects: "Projects",
    community: "Community",
    customization: "Customisation",
    reports: "Reports",
    marketing: "Marketing",
    settings: "Settings",
    my_account: 'My account',
    annual_sales: "Annual Sales",
    sales: "Sales",
    students: "Students",
    teachers: "Teachers",
    products: "Products",
    project: "Projects",
    categories: "Categories",
    category: 'Category',
    published: "Published",
    name: "Name",
    lastname: 'Surname',
    email: "Email",
    phone: "Phone",
    title: "Title",
    pass: 'Password',
    pass_confirm: 'Password confirmation',
    coming_soon: "Coming soon",
    month: "Month",
    year: "Year",
    date: "Date",
    plan: 'Plan',
    pvp: "PVP",
    net: "Net",
    total: 'Total',
    state: "State",
    delete: "Delete",
    profile: "Profile",
    enrollments: "Enrolments",
    cancel: "Cancel",
    save: "Save",
    remove: 'Remove',
    email_address: 'Email address',
    image_format: 'PNG, JPG, GIF to 3MB',
    close: 'Close',
    back: 'Back',
    coming_soon_brainspro: 'Coming soon to Brainspro',
    and: 'and',
    product: "Product",
    date_creation: 'Date of creation',
    type: 'type',

    //AppComponent
    my_profile: 'My Profile',
    adjust: 'Adjustments',
    out: 'Exit',
    search: 'Search',
    academy_preview: 'Preview academy',
    my_academy: 'My Academy',
    new_project: 'New Project',
    text_current_period: 'Your trial period to ',
    text_end_at: ' ends in ',
    plans: 'Subscription Plans',
    billing: 'User',

    //ThankYouPageComponent
    thankyou: 'Thank you!',
    go_to_academy: 'Go to the academy',

    //NavigationDesktop - Mobile
    records: 'Records',
    videos: 'Videos',

    //Aviso de cambios sin guardar (FE-032)
    unsaved_changes_title: 'You have unsaved changes',
    unsaved_changes_text: 'If you leave now, your unsaved changes will be lost.',
    unsaved_changes_leave: 'Leave without saving',
    unsaved_changes_stay: 'Keep editing',

    // FE-043 · RouteTabsComponent
    tabs: 'Tabs',

    // Botón Aula (Moodle)
    classroom_ready_title: 'The classroom is ready',
    classroom_ready_text: 'Your browser blocked the new tab. Click "Open classroom" to enter the course.',
    classroom_open: 'Open classroom',
    classroom_timeout: 'Moodle is taking too long to respond. Please try again in a few minutes.',
    classroom_error: 'The course classroom could not be opened.',

    // Menú de navegación
    users: 'Users',
    navigation_menu: 'Navigation menu',
    open_menu: 'Open menu',
    close_menu: 'Close menu',
}
